/**
 * 콜백이 주소창에 싣고 오는 코드값.
 *
 * 원본은 `apps/api/src/modules/auth/social/callback-status.ts` 다 — 값이 갈리면
 * 이 화면이 조용히 실패 화면만 띄우게 되므로, 서버 쪽을 고치면 여기도 함께 고친다.
 */
export type CallbackStatus =
  | 'signedIn'
  | 'signupRequired'
  | 'linkRequired'
  | 'blocked'
  | 'withdrawn'
  | 'emailNotVerified'
  | 'emailRequired'
  | 'failed';

/**
 * 아는 값만 통과시키는 표.
 *
 * 표로 두는 이유는 서버와 같다 — 문자열을 그대로 믿으면 주소창에 무엇을 적든
 * 화면이 따라간다. **status 는 무엇을 보여줄지만 정하고 권한에는 관여하지 않는다.**
 * `signedIn` 을 손으로 넣어도 실제 로그인은 `auth.refresh` 가 성공해야 이뤄진다.
 *
 * 객체 리터럴이 아니라 `Map` 인 이유: 일반 객체는 `Object.prototype` 을 물려받아
 * `?status=constructor` 처럼 **모든 객체가 갖고 있는 이름**으로 조회하면 함수가 튀어나온다.
 * 그 값은 `undefined` 가 아니라 기본값으로 걸러지지 않고, 문자열이 아니라 어떤 분기에도
 * 걸리지 않아 결국 안내 문구가 통째로 비고 화면이 죽는다. Map 에는 그 통로가 없다.
 */
const BY_VALUE = new Map<string, CallbackStatus>([
  ['signedIn', 'signedIn'],
  ['signupRequired', 'signupRequired'],
  ['linkRequired', 'linkRequired'],
  ['blocked', 'blocked'],
  ['withdrawn', 'withdrawn'],
  ['emailNotVerified', 'emailNotVerified'],
  ['emailRequired', 'emailRequired'],
  ['failed', 'failed'],
]);

export const toCallbackStatus = (value: unknown): CallbackStatus =>
  (typeof value === 'string' ? BY_VALUE.get(value) : undefined) ?? 'failed';
